/**
 * @generated SignedSource<<274b5e3d32d4974e5384e7777368d125>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "ThemeResponse",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "theme",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ThemeQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ThemeQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "1c1081cb7d2079631ef41cfe3b8d931e",
            "id": null,
            "metadata": {},
            "name": "ThemeQuery",
            "operationKind": "query",
            "text": "query ThemeQuery {\n  theme {\n    theme\n  }\n}\n"
        }
    };
})();
node.hash = "4b4c3d6c8d11fc6ed705979da68902b2";
export default node;
